// Subscription screen (renewal by bank transfer, payment history) and the expiry banner.
export const subscriptionEn = {
  'layout.nav.subscription': 'Subscription',
  'sub.title': 'Subscription',
  'sub.subtitle': 'Your website subscription: renew it by bank transfer and download your receipts.',
  'sub.box': 'Subscription',
  'sub.package': 'Package',
  'sub.price': 'Price',
  'sub.perMonth': '{price} / month',
  'sub.activeUntil': 'Active until',
  'sub.status': 'Status',
  'sub.stage.none': 'Not set up',
  'sub.stage.exempt': 'No subscription needed',
  'sub.stage.active': 'Active',
  'sub.stage.reminder': 'Ends soon',
  'sub.stage.grace': 'Expired',
  'sub.stage.readonly': 'Expired · read-only',
  'sub.stage.maintenance': 'Expired · site under maintenance',
  'sub.stage.off': 'Expired · site off',
  'sub.pendingChip': 'Awaiting confirmation',
  'sub.exempt': 'This website needs no subscription.',
  'sub.notSetUp': 'Your subscription has not been set up yet. Contact Digimasi to get started.',
  'sub.renew': 'Renew',
  'sub.pendingNote': 'Your payment is waiting for confirmation. We usually confirm it within one working day.',
  'sub.step.months': '1. How many months?',
  'sub.months': '{n} months',
  'sub.month': '1 month',
  'sub.noDiscount': 'Price × months, no discount.',
  'sub.total': 'Total',
  'sub.newPeriod': 'New period: {from} – {to}',
  'sub.newPeriodNote': 'Counted from the day after your current period ends, or from today if it has ended. Final dates are set when we confirm.',
  'sub.step.transfer': '2. Transfer to',
  'sub.bank': 'Bank',
  'sub.accountNumber': 'Account number',
  'sub.accountName': 'Account name',
  'sub.amount': 'Amount',
  'sub.copy': 'Copy',
  'sub.copied': 'Copied',
  'sub.step.proof': '3. Upload the transfer proof',
  'sub.proofHint': 'A screenshot or PDF of the transfer: JPG, PNG or PDF, at most 5 MB.',
  'sub.chooseProof': 'Choose the proof',
  'sub.proofTooBig': 'The file is larger than 5 MB.',
  'sub.proofWrongType': 'Use a JPG, PNG or PDF file.',
  'sub.send': 'Send for confirmation',
  'sub.cancel': 'Cancel',
  'sub.sent': 'Payment sent. We will confirm it soon.',
  'sub.history': 'Payment history',
  'sub.historyEmpty': 'No payments yet.',
  'sub.col.date': 'Sent',
  'sub.col.months': 'Months',
  'sub.col.amount': 'Amount',
  'sub.col.status': 'Status',
  'sub.col.note': 'Details',
  'sub.col.files': 'Files',
  'sub.payment.pending': 'Awaiting confirmation',
  'sub.payment.approved': 'Paid',
  'sub.payment.rejected': 'Rejected',
  'sub.period': '{from} – {to}',
  'sub.rejectedBecause': 'Reason: {reason}',
  'sub.receipt': 'Receipt',
  'sub.proof': 'Proof',
  'sub.upgrade.title': 'Need more features?',
  'sub.upgrade.body': 'Blog, more pages, more languages, team accounts, an online store: upgrade your package whenever you need it.',
  'sub.upgrade.cta': 'Upgrade / contact us',
  'sub.banner.reminder': 'Your subscription ends on {date} ({days}).',
  'sub.banner.reminderToday': 'Your subscription ends today ({date}).',
  'sub.banner.grace': 'Your subscription ended on {date}. Renew before {readOnly} to keep editing.',
  'sub.banner.readonly': 'Your subscription has ended: the CMS is read-only. Your website goes into maintenance on {maintenance} unless you renew.',
  'sub.banner.maintenance': 'Your subscription has ended: your website shows a maintenance page and the CMS is read-only. It goes off on {off}. Nothing is deleted.',
  'sub.banner.off': 'Your subscription has ended: your website is off and the CMS is read-only. Your data is kept: renew to bring everything back at once.',
  'sub.banner.pending': 'Your payment is waiting for confirmation.',
  'sub.banner.renew': 'Renew',
  'sub.banner.askAdmin': 'Ask an Admin of this site to renew.',
  'sub.days.one': '1 day left',
  'sub.days.other': '{n} days left',
  'apiError.subscriptionReadOnly': 'Your subscription has expired, so the CMS is read-only. Renew it under Subscription to make changes again.',
  'apiError.paymentPending': 'A payment is already waiting for confirmation.',
  'apiError.proofTooLarge': 'The proof is larger than 5 MB.',
  'apiError.proofType': 'The proof must be a JPG, PNG or PDF file.',
  'apiError.subscriptionNotSetUp': 'Your subscription has not been set up yet. Contact Digimasi.',
} as const

export const subscriptionId: Record<keyof typeof subscriptionEn, string> = {
  'layout.nav.subscription': 'Langganan',
  'sub.title': 'Langganan',
  'sub.subtitle': 'Langganan website Anda: perpanjang lewat transfer bank dan unduh kwitansinya.',
  'sub.box': 'Langganan',
  'sub.package': 'Paket',
  'sub.price': 'Harga',
  'sub.perMonth': '{price} / bulan',
  'sub.activeUntil': 'Aktif sampai',
  'sub.status': 'Status',
  'sub.stage.none': 'Belum diatur',
  'sub.stage.exempt': 'Tidak perlu langganan',
  'sub.stage.active': 'Aktif',
  'sub.stage.reminder': 'Segera berakhir',
  'sub.stage.grace': 'Sudah berakhir',
  'sub.stage.readonly': 'Berakhir · hanya baca',
  'sub.stage.maintenance': 'Berakhir · situs dalam pemeliharaan',
  'sub.stage.off': 'Berakhir · situs nonaktif',
  'sub.pendingChip': 'Menunggu konfirmasi',
  'sub.exempt': 'Website ini tidak perlu langganan.',
  'sub.notSetUp': 'Langganan Anda belum diatur. Hubungi Digimasi untuk memulai.',
  'sub.renew': 'Perpanjang',
  'sub.pendingNote': 'Pembayaran Anda sedang menunggu konfirmasi. Biasanya kami konfirmasi dalam satu hari kerja.',
  'sub.step.months': '1. Berapa bulan?',
  'sub.months': '{n} bulan',
  'sub.month': '1 bulan',
  'sub.noDiscount': 'Harga × jumlah bulan, tanpa diskon.',
  'sub.total': 'Total',
  'sub.newPeriod': 'Masa aktif baru: {from} – {to}',
  'sub.newPeriodNote': 'Dihitung dari hari setelah masa aktif sekarang berakhir, atau dari hari ini kalau sudah berakhir. Tanggal pastinya ditetapkan saat kami konfirmasi.',
  'sub.step.transfer': '2. Transfer ke',
  'sub.bank': 'Bank',
  'sub.accountNumber': 'Nomor rekening',
  'sub.accountName': 'Atas nama',
  'sub.amount': 'Jumlah',
  'sub.copy': 'Salin',
  'sub.copied': 'Tersalin',
  'sub.step.proof': '3. Unggah bukti transfer',
  'sub.proofHint': 'Tangkapan layar atau PDF bukti transfer: JPG, PNG, atau PDF, maksimal 5 MB.',
  'sub.chooseProof': 'Pilih bukti transfer',
  'sub.proofTooBig': 'File lebih dari 5 MB.',
  'sub.proofWrongType': 'Gunakan file JPG, PNG, atau PDF.',
  'sub.send': 'Kirim untuk konfirmasi',
  'sub.cancel': 'Batal',
  'sub.sent': 'Pembayaran terkirim. Kami akan segera mengonfirmasinya.',
  'sub.history': 'Riwayat pembayaran',
  'sub.historyEmpty': 'Belum ada pembayaran.',
  'sub.col.date': 'Dikirim',
  'sub.col.months': 'Bulan',
  'sub.col.amount': 'Jumlah',
  'sub.col.status': 'Status',
  'sub.col.note': 'Keterangan',
  'sub.col.files': 'File',
  'sub.payment.pending': 'Menunggu konfirmasi',
  'sub.payment.approved': 'Lunas',
  'sub.payment.rejected': 'Ditolak',
  'sub.period': '{from} – {to}',
  'sub.rejectedBecause': 'Alasan: {reason}',
  'sub.receipt': 'Kwitansi',
  'sub.proof': 'Bukti',
  'sub.upgrade.title': 'Butuh fitur lebih?',
  'sub.upgrade.body': 'Blog, halaman tambahan, lebih banyak bahasa, akun tim, toko online: upgrade paket kapan saja Anda butuh.',
  'sub.upgrade.cta': 'Upgrade / hubungi kami',
  'sub.banner.reminder': 'Langganan Anda berakhir pada {date} ({days}).',
  'sub.banner.reminderToday': 'Langganan Anda berakhir hari ini ({date}).',
  'sub.banner.grace': 'Langganan Anda sudah berakhir pada {date}. Perpanjang sebelum {readOnly} supaya CMS tetap bisa diubah.',
  'sub.banner.readonly': 'Langganan Anda sudah berakhir: CMS hanya bisa dibaca. Kalau belum diperpanjang, website masuk mode pemeliharaan pada {maintenance}.',
  'sub.banner.maintenance': 'Langganan Anda sudah berakhir: website menampilkan halaman pemeliharaan dan CMS hanya bisa dibaca. Website nonaktif pada {off}. Tidak ada data yang dihapus.',
  'sub.banner.off': 'Langganan Anda sudah berakhir: website nonaktif dan CMS hanya bisa dibaca. Data Anda tetap tersimpan: perpanjang dan semuanya kembali seketika.',
  'sub.banner.pending': 'Pembayaran Anda sedang menunggu konfirmasi.',
  'sub.banner.renew': 'Perpanjang',
  'sub.banner.askAdmin': 'Minta Admin situs ini untuk memperpanjang.',
  'sub.days.one': 'sisa 1 hari',
  'sub.days.other': 'sisa {n} hari',
  'apiError.subscriptionReadOnly': 'Langganan Anda sudah berakhir, jadi CMS hanya bisa dibaca. Perpanjang di menu Langganan supaya bisa mengubah lagi.',
  'apiError.paymentPending': 'Masih ada pembayaran yang menunggu konfirmasi.',
  'apiError.proofTooLarge': 'Bukti transfer lebih dari 5 MB.',
  'apiError.proofType': 'Bukti transfer harus berupa file JPG, PNG, atau PDF.',
  'apiError.subscriptionNotSetUp': 'Langganan Anda belum diatur. Hubungi Digimasi.',
}
